import { combineReducers } from 'redux'
import userSelectedSlice from './slices/userSelectedSlice';
const reducers = combineReducers({
    userSelectedSlice
})
export default reducers;